import {
  AdminStatCard,
  AdminSystemReadinessPill,
  HelpAnchor,
  Pill,
} from '@/design-system';
import { Commentable } from '@/shared/comments/Commentable';
import { SEED_ADMIN_DASHBOARD_STATS } from '@/versions/v1/shared/admin-seed';
import { AdminSceneShell } from './admin-shared';

export function AdminDashboardScene() {
  const stats = SEED_ADMIN_DASHBOARD_STATS;
  const pendingTone = stats.pendingLobby > 0 ? 'warning' : 'default';
  const serviceAlertCount = stats.servicesDown + stats.servicesDegraded;
  const serviceTone = serviceAlertCount > 0 ? 'danger' : 'default';

  return (
    <AdminSceneShell
      sceneName="AdminDashboardScene"
      title="Admin"
      stackClassName="space-y-8"
      headerActions={<HelpAnchor doc="workspace/admin" label="Admin" />}
    >
      <Commentable name="StatCards">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <AdminStatCard
            href="/admin/users"
            label="Users"
            value={stats.usersTotal}
            sub="Total accounts"
          />

          <AdminStatCard
            href="/admin/signups"
            label="Pending / lobby"
            tone={pendingTone}
            value={stats.pendingLobby}
            sub="Awaiting approval"
            alert={
              stats.pendingLobby > 0 ? (
                <Pill tone="warning">Needs review</Pill>
              ) : null
            }
          />

          <AdminStatCard
            href="/admin/projects"
            label="Projects"
            value={stats.projectsCount}
            sub="Live projects"
          />

          <AdminStatCard
            href="/admin/api-keys"
            label="API keys"
            value={`${stats.apiKeysEnabled}/${stats.apiKeysTotal}`}
            sub={`${stats.apiKeysConfigured} configured in panel`}
          />

          <AdminStatCard
            href="/admin/service-health"
            label="Services"
            tone={serviceTone}
            value={
              serviceAlertCount > 0
                ? `${stats.servicesDown} down · ${stats.servicesDegraded} degraded`
                : 'All up'
            }
            sub="API health"
            alert={
              serviceAlertCount > 0 ? (
                <Pill tone="danger">Attention needed</Pill>
              ) : null
            }
          />

          <AdminStatCard
            href="/admin/system-status"
            label="System readiness"
            valueIsElement
            value={<AdminSystemReadinessPill status={stats.systemReadiness} />}
            sub={
              stats.systemReadiness === 'ok'
                ? 'Ready for traffic'
                : 'Not ready for traffic'
            }
          />
        </div>
      </Commentable>
    </AdminSceneShell>
  );
}
